import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoUpdateBuilding, actionInventoryInfoUpdatePackage, actionInventoryInfoUpdateProfilePicture, actionInventoryInfoUpdateResource, } from "../../info/inventory/actionInventoryInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionUpdatePendingInventory, TypeActionPendingInventoryInfo, } from "../actionPendingInventoryInfo";
export var epicPendingInventoryCollectRewards = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPendingInventoryInfo.CollectRewards), switchMap(function (action) {
        var state = state$.value;
        var transferId = [action.transferId];
        var playerId = state.playerInfo.playerId;
        return deps
            .netSend({
            id: CommandCode.ConsumePendingInventory,
            props: {
                playerId: playerId,
                transferId: transferId,
            },
        })
            .pipe(switchMap(function (res) {
            var actions = [
                actionUpdatePendingInventory(playerId),
                actionInventoryInfoUpdateResource(res.resource),
                actionInventoryInfoUpdateBuilding(res.building),
                actionInventoryInfoUpdatePackage(res.package),
                actionInventoryInfoUpdateProfilePicture(res.picture),
                actionModalClose(IdModal.PendingInventory),
            ];
            return from(actions);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/epics/epicPendingInventoryCollectRewards.ts
// module id = 2036
// module chunks = 3